import React from "react"

import AppLogo from "../logos"

const NavbarAppLogo = () => (
  <React.Fragment>
    <div className="hidden sm:block">
      {/* <AppLogo width={56} /> */}
      <AppLogo width={100} />
    </div>
    <div className="block sm:hidden">
      <AppLogo width={48} />
    </div>
  </React.Fragment>
)

export default NavbarAppLogo
